<template>
  <p :class="pClass">
    <label v-if="showLabel" :for="inputId" :class="{disabled: disabled}">{{ labelText }}</label>
    <input type="text" :id="inputId" :name="inputId" size="30"
           :class="inputClass"
           :placeholder="inputPlaceholder"
           :value="value"
           v-debounce="onInput"
           @keydown.enter.prevent
           @focus="emitFocus"
           @blur="emitBlur"
           @click="emitClick"
           autocomplete="off"
           :disabled="disabled"
           :ref="inputId + 'ref'"
    />
    <a        :id="clearBtnId"
       class="clearable_btn"
       :title="'Vymazat text' | translate"
       :style="clrBtnStyle"
       @click.stop.prevent="clearText" v-translate>Vymazat
    </a>
  </p>
</template>

<script>
export default {
  name: "search-input",
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    inputId: {
      type: String,
      default: 'vyhledavani'
    },
    value: String,
    pClass: {
      type: String,
      default: 'field',
    },
    inputClass: {
      type: String,
      default: '',
    },
    inputPlaceholder: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    clearBtnId: {
      type: String,
      default: 'vyhledavani_delete',
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    clrBtnStyle() {
      if (this.value === '') {
        return 'display: none'
      } else {
        return 'display: inline'
      }
    },
    labelText() {
      if (this.label === '') {
        return this.$gettext('Vyhledávání')
      } else {
        return this.label
      }
    }
  },
  methods: {
    onInput(value) {
      this.$emit('input', value)
    },
    clearText() {
      this.$emit('input', '')
      this.$refs[this.inputId + 'ref'].focus()
    },
    emitFocus() {
      this.$emit('focus')
    },
    emitBlur() {
      this.$emit('blur')
    },
    emitClick() {
      this.$emit('click')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/SearchInput.vue